export default "__VITE_ASSET__BnTvMOII__"